/**
 * The 6 US timezone labels we accept for event posting. Stored on the event
 * doc as the `timezone` string; rendered on every display surface.
 *
 * Why labels instead of IANA zones: hosts pick what they see on a clock
 * (ET, CT, MT, PT, AKT, HT). DST is implicit ("Eastern Time" means EDT in
 * summer, EST in winter — the label hides the switch). This matches every
 * other consumer event platform (Eventbrite, Meetup) and avoids the
 * support headaches of letting hosts pick "America/Indiana/Knox".
 */
export const EVENT_TIMEZONES = [
  { value: 'ET', label: 'Eastern Time (ET)' },
  { value: 'CT', label: 'Central Time (CT)' },
  { value: 'MT', label: 'Mountain Time (MT)' },
  { value: 'PT', label: 'Pacific Time (PT)' },
  { value: 'AKT', label: 'Alaska Time (AKT)' },
  { value: 'HT', label: 'Hawaii Time (HT)' },
];

/** Best-effort default based on the user's browser locale. Falls back to ET. */
export function detectDefaultTimezone() {
  try {
    const iana = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (iana.includes('Anchorage') || iana.includes('Juneau') || iana.includes('Nome')) return 'AKT';
    if (iana.includes('Honolulu') || iana.includes('Hawaii')) return 'HT';
    if (iana.includes('Los_Angeles') || iana.includes('Tijuana') || iana.includes('Vancouver') || iana.includes('Pacific')) return 'PT';
    if (iana.includes('Denver') || iana.includes('Phoenix') || iana.includes('Mountain') || iana.includes('Edmonton')) return 'MT';
    if (iana.includes('Chicago') || iana.includes('Central') || iana.includes('Winnipeg') || iana.includes('Mexico_City')) return 'CT';
  } catch (_e) {
    // Locked-down browsers / Intl unavailable. Fall through to ET.
  }
  return 'ET';
}
